import { UserManager } from "oidc-client-ts";

const {
  VITE_GOOGLE_CLIENT_ID: CLIENT_ID = "",
  VITE_USE_MOCK_AUTH: USE_MOCK_AUTH,
} = import.meta.env;

const { origin } = globalThis.location;

// Signing in locally otherwise means a real Google account in the zymego.com
// Workspace. With USE_MOCK_AUTH the e2e mocks-server (`npm -w e2e run mocks`)
// stands in for Google, so the redirect comes straight back with a code.
const authority =
  USE_MOCK_AUTH === "true"
    ? "http://localhost:3100"
    : "https://accounts.google.com";

const userManager = new UserManager({
  authority,
  client_id: CLIENT_ID,
  redirect_uri: `${origin}/auth/callback`,
  response_type: "code",
  disablePKCE: true,
  scope: "openid profile email",
  automaticSilentRenew: true,
});

export { userManager };
